import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayers12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconLayers12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.087 3.56 6.001 2.003 2.916 3.561 6 5.119zM6.452 1.11a1 1 0 0 0-.901 0L1.405 3.204a.4.4 0 0 0 0 .714L5.55 6.012a1 1 0 0 0 .901 0L10.6 3.918a.4.4 0 0 0 0-.714zm-5.4 4.416a.5.5 0 0 1 .672-.223L6 7.44l4.276-2.138a.5.5 0 0 1 .448.894l-4.5 2.25L6 8.56l-.224-.112-4.5-2.25a.5.5 0 0 1-.224-.67m.671 2.027a.5.5 0 0 0-.447.894l4.5 2.25.224.112.224-.112 4.5-2.25a.5.5 0 1 0-.447-.894L6 9.69z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayers12);
